import React, { useState, useEffect } from 'react';
import { Divider, Tabs, Tooltip } from 'antd';
import { ButtonGroup, Button } from '@mui/material';

const { TabPane } = Tabs;


const weightOptions = [
    { key: 'prorata', label: 'Pro Rata', description: 'Weight based on the market cap or another metric.' },
    { key: 'equal', label: 'Weight Equal', description: 'Equal weight across all assets.' },
    { key: 'sectorRefill', label: 'Sector Refill', description: 'Refill sectors to match a target allocation.'},
];

export const WeightSchemeNav = ({ onWeightOptionChange, currentWeightOption }) => {
    console.log("CURRENT WEIGHT OPTION", currentWeightOption)
  return (
    <ButtonGroup aria-label="weight-options" exclusive type={'primary'}>
      {weightOptions.map(option => (
        <Tooltip title={option.description} key={option.key}>
          <Button onClick={() => onWeightOptionChange(option.key)} variant={option.key === currentWeightOption ? 'contained' : 'outlined'}>
            {option.label}
          </Button>
        </Tooltip>
      ))}
    </ButtonGroup>
  );
};

export const ToggleGroupedBars = ({ setDisplayField, setView }) => {
    const handleChange = (key) => {
        if (key === 'aggregated'){
            setView('aggregated');
        }
        else {
            setDisplayField(key)
        }
    };

    return (
        <Tabs style={{paddingLeft: '50px'}} defaultActiveKey="wgt" onChange={handleChange} type="card">
            <TabPane tab='Back to Table' key={'aggregated'} />
            <TabPane tab="Show Weights" key="wgt" />
            <TabPane tab="Show Counts" key="count" />
        </Tabs>
    );
};